import React, { memo, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Selector } from "app/components/common/Selector";
import { makeStyles } from "@material-ui/core";
import { TagSelector } from "app/components/common/TagSelector";
import { selAirlinePermissionGroups } from "app/routes/dashboard/routes/adminGroupAndPermissions/slice/groupsSlice";
import { getAirlinePermissionGroups } from "app/routes/dashboard/routes/adminGroupAndPermissions/slice/groupsThunk";
/* -------------------------------------------------------------------------- */
export const PermissionGroupsSelector = memo(
  ({
    multiple,
    onChange,
    label,
    inputLabel,
    hasNone,
    error,
    value,
    values,
    noneOptionText,
    className,
  }) => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const airlinePermissionGroups = useSelector(selAirlinePermissionGroups);
    const [selectedValues, setValues] = useState([]);
    const adminId = useMemo(
      () =>
        airlinePermissionGroups?.find((group) => group.title === "Admin")?.id,
      [airlinePermissionGroups]
    );
    const filteredGroups = useMemo(
      () =>
        airlinePermissionGroups?.filter(
          (group) => group.title !== "Admin" || true
        ),
      [airlinePermissionGroups]
    );
    const hasAdmin = values?.includes(adminId);
    const options = filteredGroups?.map((option) => ({
      value: option.title,
      id: option.id,
    }));
    useEffect(() => {
      if (!(airlinePermissionGroups?.length > 0))
        dispatch(getAirlinePermissionGroups());
    }, [airlinePermissionGroups]);

    useEffect(() => {
      if (airlinePermissionGroups?.length > 0) setValues(values);
      return () => {};
    }, [values, airlinePermissionGroups]);

    const handleTagSelectorChange = (data) => {
      let changedData = new Set([...data]);
      if (hasAdmin && !changedData.has(adminId)) changedData.add(adminId);
      let polishedData = [...changedData].filter((d) => !!d);
      onChange(polishedData);
    };
    return multiple ? (
      <TagSelector
        selected={selectedValues}
        label={label}
        inputLabel={inputLabel}
        error={error}
        onChange={handleTagSelectorChange}
        options={options}
        filterSelectedOptions
        disabledOptions={[adminId]}
      />
    ) : (
      <Selector
        value={value}
        label={label}
        inputLabel={inputLabel}
        options={airlinePermissionGroups?.map((group) => {
          return { id: group.id, value: group.title };
        })}
        hasNone={hasNone}
        noneOptionText={noneOptionText}
        onChange={onChange}
        error={error}
      />
    );
  }
);
/* -------------------------------------------------------------------------- */
const useStyles = makeStyles(
  (theme) => ({
    autocomplete: {
      minWidth: 170,
      "& .MuiAutocomplete-inputRoot.MuiOutlinedInput-root": {
        // padding: 0,
      },
      "& .MuiAutocomplete-noOptions": {
        display: "none",
      },
    },
    popper: {
      // width: "max-content!important",
      "& .MuiAutocomplete-listbox": {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        paddinginline: theme.spacing(1),
        "& li": {
          padding: "4px 0px",
        },
      },
    },
    noOptions: {
      display: "none",
    },
    optionContent: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      flex: 1,
    },
    optionCode: { fontSize: 8, color: theme.palette.primary.main },
    chip: {
      height: theme.spacing(3),
      marginInline: "4px",
      "& .MuiChip-label": {
        fontSize: 12,
      },
    },
    multiline: {
      "& .MuiInputBase-root": {
        height: "auto",
        minHeight: 36,
        paddingRight: `${theme.spacing(1)}px !important`,
      },
      "& .MuiChip-root": {
        marginTop: 4,
      },
    },
  }),
  { name: "TagSelector" }
);
